// Must be kept in sync with Azure Function code
// @see: https://dev.azure.com/bluegrace-vsts/Nebula/_git/BS.RateQuality?path=/BS.RateQuality.Functions/BatchRates/Entities
export const COLUMN_NAMES = {
  PULL_DATA: 'Pull Data',
  FROM_DATE: 'From Date',
  TO_DATE: 'To Date',
  ACCOUNT_NAME: 'Account Name',
  ACCOUNT_NUMBER: 'Account Number',
  CARRIER_TIERS: 'Carrier Tiers',
  CARRIER_EXCLUSION: 'Carrier Exclusion',
  CARRIER_INCLUSION: 'Carrier Inclusion',
  ANALYSIS_TYPE: 'Analysis Type',
  MARKUP_TYPE: 'Markup Type',
  MARKUP_PERCENT_TYPE: 'Markup % Type',
  MARKUP_AMOUNT: 'Markup ($ or %)',
  NOTIFICATION_EMAIL: 'Notification Email',
  IMPACT_CARRIER_EXCLUSIONS: 'Impact Carrier Exclusions',
  IMPACT_ORIGIN_POSTAL_EXCLUSIONS: 'Impact Origin Postal Exclusions',
  IMPACT_ORIGIN_STATE_EXCLUSIONS: 'Impact Origin State Exclusions',
  IMPACT_DESTINATION_POSTAL_EXCLUSIONS: 'Impact Destination Postal Exclusions',
  IMPACT_DESTINATION_STATE_EXCLUSIONS: 'Impact Destination State Exclusions',
  INCLUDE_DYNAMIC_QUOTES: 'Include Dynamic Quotes',
  INCLUDE_VOLUME_QUOTES: 'Include Volume Quotes',
  SYSTEMS_TO_RATE: 'Systems To Rate',
} as const;
